// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import './utils/dw-common'
import 'font-awesome/css/font-awesome.min.css'
import DwAuthorized from './utils/dw-authorized'


Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VueAxios, axios)
Vue.component('icon', Icon)
router.beforeEach((to, from, next) => {
  // 全局设置token auth
  if (this.$route !== undefined) {
    const query = this.$route.query
    if (query!==undefined && query !== null) {
      if (query.hasOwnProperty('token')) {
        const token = query.token
        console.log('token', token)
        DwAuthorized.setToken(token)
      }
      if (query.hasOwnProperty('authed')) {
        const authed = query.authed
        console.log('authed', authed)
        DwAuthorized.setAuthorityStr(authed)
      }
      if (query.hasOwnProperty('userName')) {
        const userName = query.userName
        console.log('userName', userName)
        DwAuthorized.setUserName(userName)
      }
    }
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js